import type { OptimizelyDecision } from '@optimizely/optimizely-sdk';
import {
  SET_INITIAL_DECISIONS,
  type OptimizelyAllDecision,
} from '@redux/reducers-optimizely-factory';

export const setInitialDecisions = (
  initialDecisions: OptimizelyAllDecision,
) => {
  return {
    type: SET_INITIAL_DECISIONS,
    payload: initialDecisions,
  };
};

export const hasStoredDecision = (state: any, key: string) => {
  if (state?.optimizely && state.optimizely.initialDecisions?.[key]) {
    return state.optimizely.initialDecisions[key] as OptimizelyDecision;
  }

  return;
};

export const getEnabledDecision = (state: any, key: string) => {
  if (state?.optimizely && state.optimizely.initialDecisions?.[key]) {
    const { userContext } = state.optimizely.initialDecisions[
      key
    ] as OptimizelyDecision;
    const decision = userContext.decide(key);

    if (decision?.enabled) return decision;
  }

  return;
};
